$(function() {
    const myajax = `//${window.location.host}/wp-admin/admin-ajax.php`;

    const paramObj = {
        action: 'load_post',
        postType: 'locations',
        url: myajax,
        catId: 'all',
        paged: 1,
    };

    function updateUrl($filter) {
        const url = new URL(window.location.href);
        const city = $filter.data('city');
        const filter = $filter.data('filter');

        if (city && city !== 'all') {
            url.searchParams.set('city', city);
        } else {
            url.searchParams.delete('city');
        }

        if (filter && filter !== 'all') {
            url.searchParams.set('filter', filter);
        } else {
            url.searchParams.delete('filter');
        }

        window.history.pushState({}, '', url.toString());
    }

    function loadPosts() {
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',

            beforeSend() {
                $('.js-ajax-load').css({
                    opacity: '.3',
                    'pointer-events': 'none'
                });
            },

            success(data) {
                $('.js-ajax-load').html(data);
            },

            complete() {
                $('.js-ajax-load').css({
                    opacity: '1',
                    'pointer-events': 'auto'
                });
            }
        });
    }

    function setFilterFromUrl() {
        const params = new URLSearchParams(window.location.search);
        const city = params.get('city');
        const filter = params.get('filter');

        if (!city && !filter) {
            paramObj.catId = 'all';
            $('.js-load-post').removeClass('is-active');
            $('.js-load-post[data-cat-id="all"]').addClass('is-active');
            loadPosts();

            return;
        }

        let $filter = null;

        if (city) {
            $filter = $('.js-load-post').filter(function() {
                return String($(this).data('city')) === city;
            }).first();
        }

        if (!$filter.length && filter) {
            $filter = $('.js-load-post').filter(function() {
                return String($(this).data('filter')) === filter;
            }).first();
        }

        if ($filter.length) {
            paramObj.catId = $filter.data('cat-id');

            $('.js-load-post').removeClass('is-active');
            $filter.addClass('is-active');

            loadPosts();
        } else {
            paramObj.catId = 'all';

            $('.js-load-post').removeClass('is-active');
            $('.js-load-post[data-cat-id="all"]').addClass('is-active');

            loadPosts();
        }
    }

    $('body').on('click', '.js-load-post', function(e) {
        e.preventDefault();

        const $this = $(this);
        const catID = $this.data('cat-id');

        $('.js-load-post').removeClass('is-active');
        $this.addClass('is-active');

        paramObj.catId = catID ? catID : 'all';
        paramObj.paged = 1;

        updateUrl($this);
        loadPosts();
    });

    setFilterFromUrl();
});